//SIN-DEV_70 ステップ表示部分のレスポンシブ対応
//表示崩れが発生しないよう画面幅に応じてcolsを調整する関数
export const getStepCols = () => {
  //表示崩れの起きない画面幅の場合
  if(1127 <= window.innerWidth) return 6
  //cols=6だと崩れる かつ cols=12だと広すぎる場合
  else if(896 <= window.innerWidth && window.innerWidth <= 1126) return 8
  //cols=8のままだと崩れる場合
  else return 12
}

//SIN_DEV-54 管理者 お知らせ新規作成 レスポンシブ対応
export const getNotificationCols = () => {
  //iPadの場合は表示幅を広げる
  if(window.innerWidth <= 1024) return 8
  //通常時のcols
  else return 4
}